













































































import Vue from "vue";
import { PropType } from "vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import DuplicationFloatingView from "@/components/Pages/Plans/Molecules/DuplicationFloatingView/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import PlanListItem from "@/components/Pages/Plans/Molecules/PlanListItem/index.vue";
import CreatePlanFloatingView from "@/components/Pages/Plans/Molecules/CreatePlanFloatingView/index.vue";
import UpdatePlanFloatingView from "@/components/Pages/Plans/Molecules/UpdatePlanFloatingView/index.vue";
import DeletePlanFloatingView from "@/components/Pages/Plans/Molecules/DeletePlanFloatingView/index.vue";

import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Plans",
  components: {
    Button,
    ButtonConfig,
    Heading,
    Caption,
    PlanListItem,
    CreatePlanFloatingView,
    UpdatePlanFloatingView,
    DuplicationFloatingView,
    DeletePlanFloatingView
  },
  props: {
    plans: {
      type: Array as PropType<Props["plans"]>,
      required: true
    },
    availableGraduateYears: {
      type: Array as PropType<Props["availableGraduateYears"]>,
      required: true
    },
    messages: {
      type: Array as PropType<Props["messages"]>,
      required: true
    },
    isCreateFloatingViewVisible: {
      type: Boolean as PropType<Props["isCreateFloatingViewVisible"]>,
      required: true
    },
    isDuplicationFloatingViewVisible: {
      type: Boolean as PropType<Props["isDuplicationFloatingViewVisible"]>,
      required: true
    },
    isUpdateFloatingViewVisible: {
      type: Boolean as PropType<Props["isUpdateFloatingViewVisible"]>,
      required: true
    },
    isDeleteFloatingViewVisible: {
      type: Boolean as PropType<Props["isDeleteFloatingViewVisible"]>,
      required: true
    }
  },
  data() {
    return {
      selectedPlanId: null,
      initSelectedPlan: {
        id: 0,
        name: "",
        graduate_year: 0
      }
    };
  },
  computed: {
    selectedPlan() {
      // NOTE: 削除後は戻り値がundefinedになりエラーとなるためplans[0]を代わりに使用している（エラー回避）
      return this.plans!.find(plan => plan.id === this.selectedPlanId)
        ? this.plans!.find(plan => plan.id === this.selectedPlanId)
        : { ...this.initSelectedPlan };
    },
    formattedAvailableGraduateYears() {
      return this.availableGraduateYears.map(availableGraduateYear => ({
        label: String(availableGraduateYear),
        value: String(availableGraduateYear)
      }));
    }
  },
  methods: {
    handleClickCreateFloatingViewOpen() {
      this.$emit("clickCreateFloatingViewOpen");
    },
    handleClickCreateFloatingViewClose() {
      this.$emit("clickCreateFloatingViewClose");
    },
    handleCreatePlan(name, graduateYear) {
      this.$emit("createPlan", name, graduateYear);
    },
    handleClickUpdateFloatingViewClose() {
      this.$emit("clickUpdateFloatingViewClose");
    },
    handleClickUpdatePlan(updatePlan) {
      this.$emit("updatePlan", updatePlan);
    },
    handleClickDeletePlanViewVisible() {
      this.$emit("clickDeleteFloatingViewOpen");
    },
    handleClickDeletePlanViewClose() {
      this.$emit("clickDeleteFloatingViewClose");
    },
    handleClickUpdateFloatingViewOpen({ planId }) {
      this.selectedPlanId = planId;
      this.$emit("clickUpdateFloatingViewOpen");
    },
    handleClickDuplicationFloatingViewOpen({ planId }) {
      this.selectedPlanId = planId;
      this.$emit("clickDuplicationFloatingViewOpen");
    },
    handleClickDuplicationFloatingViewClose() {
      this.$emit("clickDuplicationFloatingViewClose");
    },
    handleClickDuplicationPlanCreate(duplicationPlan) {
      this.$emit("clickDuplicationPlanCreate", duplicationPlan);
    },
    handleClickDeletePlan() {
      if (!this.selectedPlanId) return;
      this.$emit("deletePlan", this.selectedPlanId);
    }
  }
});
